import { createDataSelectors } from "@app/modules/app.reducers";
import { UserGroup } from "@ea/shared_types/types";

export const userGroupDataSelectors = createDataSelectors<UserGroup>()("userGroups");
